module.exports = {"id":"204523","name":"Rubén Pardo","rating":"77","photo":"./data/images/photos/0/204523.png","club":{"name":"Real Sociedad","logo":"./data/images/clubs/RealSociedad.png"},"positions":["MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenPardo0.json
// module id = 3738
// module chunks = 0